import React, {Component} from "react";
import HttpRequest from "../../../HttpRequest";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import Route from "../../../Route";
import {Tools} from "../../../Tools";
import Link from "../../../components/Link";


const loadingInButtonLabel = (
    <>
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
        Loading...
    </>
),
applicationsButtons = {
    seeProof: {
        type: "a",
        className: "btn btn-default",
        href: "#",
        label: "Voir le justificatif",
        attributes: {
            "member" : "",
            "data-name" : "seeProof",
            "target" : "_blank",
        },
        handleClick: null,
    },
    validateMember: {
        type: "a",
        className: "btn btn-success",
        href: "#",
        label: "Valider l'adhésion",
        attributes: {
            "member" : "",
            "data-name" : "validateMember",
        },
        handleClick: null,
    },
    relaunchProofMember: {
        type: "a",
        className: "btn btn-primary",
        href: "#",
        label: "Relancer le membre",
        attributes: {
            "member" : "",
            "data-name" : "relaunchProofMember"
        },
        handleClick: null,
    },
};

/**
 * Application is refer to demande d'adhésion in french
 */
class Applications extends Component{
    constructor(props){
        super(props);
        this.handleButtonClicked = this.handleButtonClicked.bind(this);

        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            applicationsButtons: applicationsButtons
        };
        this.query = {};
    }

    handlerDashboardChange(dashboard){
        if(this.props.onDashboardChange){
            this.props.onDashboardChange(dashboard);
        }
    }

    handleButtonClicked(event){
        const currentTarget = event.target;
        const name = currentTarget.getAttribute("data-name");
        if(name !== "seeProof"){
            event.preventDefault();
        }
        let member = currentTarget.getAttribute("member");

        if(applicationsButtons.hasOwnProperty(name) && member){
            member = Tools.StringToJson(member);
            const members = this.state.members,
                index = Tools.GetItemIndex("slug", member.slug, members),
                memberItem = members[index]
            ;

            if(name === "seeProof"){
                // Redirect to another tab to see member proof
                if(!member.proof){
                    event.preventDefault();
                    alert("Ce membre n'a pas de justificatif. Contactez le developpeur pour voir ce problème.");
                }
                return;
            }
            let buttons = Tools.Clone(memberItem.buttons);
            buttons[name].label = loadingInButtonLabel;
            buttons[name].attributes = {...buttons[name].attributes, disabled: true};
            members[index].buttons = buttons;
            this.setState({members: members});

            // Async method
            this.setApplication("POST", {
                uuid: member.uuid,
                buttonAction: name
            });
        }
    }

    render() {
        let element = <h3 className="">Aucune demande d'adhésion en attente de validation.</h3>
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else{
            if(!Tools.IsEmpty(this.state.members)){
                element = this.state.members.map((member) => {
                    return (
                        <div key={member.slug} className="row mb-4">
                            <div className="col-md-2">
                                <img src={Route.APIBaseUrl + Route.APILoadMemberFile + member.avatar} className="img-thumbnail img-responsive" alt={member.name + " avatar"} width="150" />
                            </div>
                            <div className="col-md-6 paragraph ">
                                <h4>{member.civility + ". " + member.name.toUpperCase() + " " + member.firstName}</h4>
                                <div>Cycle : <strong>{member.cycle.toUpperCase()}, </strong>{member.hasFinishedCycle ? "a" : "n'a pas" } terminé son cycle</div>
                                <div>Promotion : <strong>{member.promotion}</strong></div>
                                <div>Profession : <strong>{member.profession  && member.profession.name ? member.profession.name : ""}</strong></div>
                                <div>Email : <strong>{member.email}</strong></div>
                                <div>Date de demande : <strong>{member.createdAt}</strong></div>
                            </div>
                            <div className="col-md-3">
                                {
                                    member.hasProof ?
                                        <>
                                            <Link data={member.buttons.seeProof} />
                                            <br/>
                                            <br/>
                                            <Link data={member.buttons.validateMember} />
                                        </>
                                        :
                                        <>
                                            <strong className="label label-danger">Justificatif en attente</strong>
                                            <br/>
                                            <br/>
                                            <Link data={member.buttons.relaunchProofMember} />
                                            {
                                                member.actionMessage ?
                                                    <div>
                                                        <br/>
                                                        <strong className="label label-success mt-3">{member.actionMessage}</strong>
                                                    </div>
                                                    :
                                                    ""
                                            }
                                        </>
                                }

                            </div>
                        </div>
                    );
                });
                element = (
                    <>
                        <h3 className="">{this.state.members.length} Demande(s) d'adhésion en attente de validation.</h3>
                        <br/>
                        {element}
                    </>
                );
            }
        }

        return element;
    }


    componentDidMount() {
        this.loadApplications();
    }

    componentWillUnmount() {
        this.httpClient.cancelRequest();
    }

    loadApplications() {
        this.setApplication("GET");
    }

    setApplication(method, body = null){
        const _self = this;
        this.httpClient.request(Route.APIMembersApplications, method, {}, body ? body : {}).then(function (response){
            _self.server = response;
            _self.setState(response.code === 200 ? _self.buildData(response.data) : {server: response, isLoadCompleted: true, hasError: true});
        }).catch(function (error){
            _self.server = error;
            _self.setState({server: error, hasError: true });
        });
    }

    buildData(data){
        const _self = this,
            members = data.members.map((member) => {
            member.buttons = {
                seeProof: {
                    ..._self.state.applicationsButtons.seeProof,
                    attributes: {..._self.state.applicationsButtons.seeProof.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked,
                    href: Route.APIBaseUrl + Route.APILoadMemberFile + member.proof
                },
                validateMember: {
                    ..._self.state.applicationsButtons.validateMember,
                    attributes: {..._self.state.applicationsButtons.validateMember.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked
                },
                relaunchProofMember: {
                    ..._self.state.applicationsButtons.relaunchProofMember,
                    attributes: {..._self.state.applicationsButtons.relaunchProofMember.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked
                }
            };
            return {...member};
        });
        const dashboard = {
            ..._self.props.data.dashboard,
            applicationsCount: members.length,
            membersValidCount: _self.props.data.dashboard.membersCount - members.length
        }
        _self.handlerDashboardChange(dashboard);
        return {
            hasError: false,
            isLoadCompleted: true,
            members: members,
            isTableRowLoadCompleted: true,
        };
    }
}

export default Applications;